import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';
import { ModifierManager } from './ModifierManager';

export const advisorRoles = ['Treasurer', 'Marshal', 'Chancellor', 'High Priest', 'Spymaster', 'Admiral', 'Architect'] as const;

export class AdvisorManager {
  static readonly instance = new AdvisorManager();

  advisorsForFaction(factionId: string) {
    const advisors = DataRegistry.instance.advisorList().filter((advisor) => advisor.faction === factionId);
    if (advisors.length) return advisors;
    return advisorRoles.map((role, index) => ({
      id: `${factionId}_${role.toLowerCase().replaceAll(' ', '_')}`,
      name: `${DataRegistry.instance.factions[factionId]?.name ?? factionId} ${role}`,
      faction: factionId,
      role,
      skill: 4 + (index % 4),
      trait: ['Just', 'Tactician', 'Scholar', 'Diplomat'][index % 4],
      portraitAsset: `portrait_${factionId}_${role === 'Marshal' ? 'general' : role === 'High Priest' ? 'high_priest' : role.toLowerCase().replaceAll(' ', '_')}`,
    }));
  }

  assignAdvisor(factionId: string, role: string, advisorId: string) {
    const faction = GameState.instance.requireCampaign().factions[factionId];
    if (!faction) return false;
    const alreadyAssigned = Object.values(faction.advisorSlots).filter(Boolean).length;
    const replacing = Boolean(faction.advisorSlots[role]);
    if (!replacing && alreadyAssigned >= this.capacity(factionId)) {
      GameState.instance.log(`Advisor council capacity is ${this.capacity(factionId)}. Enact laws or research Court Records to expand it.`, 'warning');
      return false;
    }
    faction.advisorSlots[role] = advisorId;
    GameState.instance.log(`${role} assigned.`, 'success');
    return true;
  }

  capacity(factionId: string) {
    const faction = GameState.instance.requireCampaign().factions[factionId];
    if (!faction) return 0;
    return 3 + ModifierManager.instance.forFaction(factionId).advisorCapacityBonus;
  }
}
